/** Apple's scroll deceleration rate, used to project where a thrown page lands. */
export const DECELERATION_RATE = 0.998;
/** A release counts as "thrown back" (cancel) below this velocity, px/s. */
export const CANCEL_VELOCITY = -200;

export interface TouchSample {
  x: number;
  /** Event timestamp in ms. */
  t: number;
}

/** Horizontal velocity in px/s across the recent touch samples (0 if not measurable). */
export function releaseVelocity(samples: TouchSample[]): number {
  const first = samples[0];
  const last = samples[samples.length - 1];
  if (!first || !last || last.t <= first.t) return 0;
  return ((last.x - first.x) / (last.t - first.t)) * 1000;
}

/** Where the page would come to rest if let go now, carrying its velocity. */
export function projectedOffset(x: number, velocity: number): number {
  return x + ((velocity / 1000) * DECELERATION_RATE) / (1 - DECELERATION_RATE);
}

/** Finish the swipe-back if the page would come to rest past half the screen. */
export function shouldCompleteSwipe(x: number, velocity: number, width: number): boolean {
  return projectedOffset(x, velocity) > width * 0.5 && velocity > CANCEL_VELOCITY;
}

/** Finger travel before a touch counts as a swipe in either direction, px. */
export const SWIPE_SLOP = 10;

/**
 * What an edge touch is turning into, from its travel so far: still unclear,
 * a swipe back (mostly rightward), or not a swipe (vertical scroll or leftward).
 */
export function swipeIntent(dx: number, dy: number): 'pending' | 'back' | 'none' {
  if (Math.abs(dx) < SWIPE_SLOP && Math.abs(dy) < SWIPE_SLOP) return 'pending';
  if (dx <= 0) return 'none';
  return Math.abs(dy) / dx > 0.5 ? 'none' : 'back';
}
